export default "__VITE_ASSET__CH69$Bop__"